import React, { useEffect, useState } from 'react';
import { documentTagServices } from '../../../APIServices/documentTagServices';
import { useToast } from '../../../hooks/useToast';

function UpdateDocumentTag({
  documentTagData,
  setConfirm,
  confirm,
  setModalOpen,
  getDocumentTagData,
}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [documentTag, setDocumentTag] = useState('');

  const updateDocumentTagData = async () => {
    setButtonLoader(true);
    try {
      const data = await documentTagServices.updateDocumentTagData({
        documentTagId: documentTagData?.documentTagId,
        documentTag,
      });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Document tag updated successfully.', 'ok');
        getDocumentTagData();
        setConfirm(false);
        setModalOpen('');
        setDocumentTag('');
      } else {
        toast(data?.customMessage || 'Unable to update document tag.', 'warn');
      }
    } catch (error) {
      toast('Unable to update document tag. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    setDocumentTag(documentTagData?.documentTag || '');
  }, [documentTagData]);

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Edit Document Tag</div>
            <div className="xs muted">Update the document tag details</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Document Tag Name
              <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader || confirm}
              placeholder="e.g., Critical"
              value={documentTag}
              onChange={(e) => setDocumentTag(e.target.value)}
            />
          </div>
        </div>
        <div className="modal-foot">
          {confirm ? (
            <>
              <button className="btn btn-ghost" onClick={() => setConfirm(false)}>Cancel</button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={updateDocumentTagData}
                disabled={buttonLoader || !documentTag}
              >
                {buttonLoader ? (
                  <>
                    <div className="buttonLoader"></div>
                    <span>Updating...</span>
                  </>
                ) : (
                  <>
                    <i className="ti ti-check"></i>
                    <span>Yes, Update It!</span>
                  </>
                )}
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
              <button className="btn btn-primary d-flex align-items-center justify-content-center gap-2" onClick={() => setConfirm(true)}>
                Update Document Tag
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default UpdateDocumentTag;
